<template>
    <div data-component="TodayViewLinearTableCell"
         class="linear-view-table__cell-session-container">
        <TodayViewLinearTableCellTrack v-for="(track, trackIndex) in paddedTracks"
                                       :key="trackIndex"
                                       :track="track"
                                       :track-style="trackStyle" />
    </div>
</template>

<script>
import TodayViewLinearTableCellTrack from './TodayViewLinearTableCellTrack';

export default {
    components: {
        TodayViewLinearTableCellTrack,
    },

    props: {
        tracks: {
            type: Array,
            required: true,
        },
        maxTracks: {
            type: Number,
            required: true,
        },
        cell: {
            type: Number,
            required: true,
        },
    },

    computed: {
        // Todo
        // At the moment this returns an array of arrays. I think we can simplify this to just return
        // an array of objects.
        paddedTracks() {
            if (this.tracks.length === 0) {
                return [];
            }
            const padded = [...this.tracks];

            // Add empty tracks until we reach maxTracks so every cell in a row either has no tracks or the same
            // number of tracks. We need to do this so that the tracks can be vertically centered consistently in
            // each cell of a given row.

            // Add empty tracks until we reach maxTracks
            while (padded.length < this.maxTracks) {
                padded.push([]);
            }

            return padded;
        },

        /**
         * The tracks need to have descending z-index so that a session defined in an earlier cell will always sit
         * over the top of a later cell. If we don't do this then empty tracks used a spacers will sit over the top
         * of preceding sessions and block the mouse events.
         *
         * @return {string}
         */
        trackStyle() {
            return 'z-index: ' + (59 - this.cell);
        },
    },
};
</script>

<style lang="less">
@import "../../../../../less/variables";
@import (less, reference) "../../../../../less/vendor/fontawesome.less";

.linear-view-table__cell-session-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    height: 100%;
    justify-content: center;
}

// Delete - moved into the track component
.linear-view-table__cell-session-track {
    position: relative;
    height: 40px;
    flex-shrink: 0;
}
</style>
